<div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start center" class="mt-3">
  <div fxLayout="row" fxLayoutGap="10px">
    <span>{{'common.qualifies' | translate }}:</span>
    <span>{{ charityCareQualificationStatus | translate | mmxTitlecase}}</span>
  </div>
  <div
    *ngIf="!!patientCharityCareStatus"
    fxLayout="row"
    fxLayoutGap="10px"
  >
    <span>{{'common.last-ran' | translate }}:</span>
    <span>{{ patientCharityCareStatus?.lastUpdatedAt | momentDate: (timezone ?? DEFAULT_TIMEZONE) }}</span>
  </div>

  <button
    *ngIf="canShowTrace"
    mat-icon-button
    color="primary"
    type="button"
    class="charity-care-summary__trace-button"
    data-testid="charity-care-trace-button"
    [disabled]="traceLoading"
    (click)="onTrace()"
    [matTooltip]="'charity-care-summary.trace' | translate"
    [attr.aria-label]="'charity-care-summary.trace' | translate"
  >
    <mat-icon>receipt_long</mat-icon>
  </button>
</div>
